export const CHAT_KEYWORDS: any[] = [
  // {
  //   words: '店舗2',
  //   link: '/xxx/xxx',
  // },
];
